import React, { type MouseEvent } from "react";
import { useContextMonths, useContextMonthsPropGetters, useDatePickerStateContext } from "@rehookify/datepicker";
import { twJoin } from "tailwind-merge";
import { setDate, getDate, lastDayOfMonth } from "date-fns";

import { SupText } from "../../../../components/UI/Text";

interface MonthPickerProps {
  onMonthPick?: (date?: Date) => void;
}

export function MonthPicker({ onMonthPick }: MonthPickerProps) {
  const { months } = useContextMonths();
  const { monthButton } = useContextMonthsPropGetters();
  const { offsetDate } = useDatePickerStateContext();

  function handleMonthPick(_: MouseEvent<HTMLElement>, date: Date) {
    onMonthPick?.(date);
  }

  return (
    <div className="sup-month-picker px-2">
      <div className="grid grid-cols-3 gap-y-2 py-2 w-64">
        {months.map(m => {
          const lastDay = getDate(lastDayOfMonth(m.$date));
          const selectedDay = getDate(offsetDate);
          const date = setDate(m.$date, selectedDay > lastDay ? lastDay : selectedDay);

          return (
            <span key={m.$date.getTime()} className="text-center">
              <SupText
                as="button"
                variant="subtitle2"
                disabled={m.disabled}
                className={twJoin(
                  "px-2 py-2.5 transition-colors duration-200 disabled:opacity-44",
                  m.selected ? "bg-primary-300 text-neutral-900" : "enabled:hover:bg-primary-100 enabled:hover:text-neutral-900"
                )}
                {...monthButton({ ...m, $date: date }, { onClick: handleMonthPick })}
              >
                {m.month}
              </SupText>
            </span>
          );
        })}
      </div>
    </div>
  );
}
